import { Box, Grid, IconButton, Typography } from "@mui/material"
import MenuItem from '@mui/material/MenuItem'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import ManageWebApi from "api/application/manageWeb"
import { WebContactUsProps } from "api/application/manageWeb-interface"
import BtnCopy from "assets/button/BtnCopy"
import BtnFacebook from "assets/button/BtnFacebook"
import BtnIG from "assets/button/BtnIG"
import BtnLine from "assets/button/BtnLine"
import BtnTiktok from "assets/button/BtnTiktok"
import BtnWebsite from "assets/button/BtnWebsite"
import InputNewRangeTimePicker from "component/Input/InputNewRangeTimePicker"
import InputTextField from "component/Input/InputTextField"
import InputTextarea from "component/Input/InputTextarea"
import Loading from "component/Loading"
import BasicSelect from "component/Select/BasicSelect"
import { notiError } from "component/notifications/notifications"
import { icons } from "constants/images"
import { colors } from "constants/theme"
import * as UseStyles from 'features/application/manage-web/contact-us/style'
import _ from "lodash"
import moment from "moment"
import MainButton from "new-components/buttons/main-button"
import { HelperText } from "new-components/inputs/helper-text"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"


type ContactUsFormProps = {
    dataContact?: any
    branchContact?: any
    branchId?: number
    index: number
    status: boolean
    setStatus: (value: any) => void
}

const ContactUsForm = (props: ContactUsFormProps) => {
    const initStateErrorMessage = { CN_NAME: ``, EMAIL: ``, PHONE: ``, DETAIL: ``, WORK_TIME_LIST: ``, WORK_TIME: `` }
    const { t } = useTranslation()
    const t_CONTACT_US = "MANAGE_WEB.CONTACT_US"
    const objBranchTime = [{ typetime: 'OPEN', timeStart: '00:00', timeEnd: '00:00', days: { sun: false, mon: false, tue: false, wed: false, thu: false, fri: false, sat: false } }]
    const [dataEdit, setDataEdit] = useState<any>(props.dataContact)
    const [branchTimes, setBranchTimes] = useState<any>([...objBranchTime])
    const dateOfWeek = [`Mon`, `Tue`, `Wed`, `Thu`, `Fri`, `Sat`, `Sun`]
    const officeTimes = [{}]
    const [statusAdd, setStatusAdd] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
    const [isFormReady, setIsFormReady] = useState<boolean>(false)


    useEffect(() => {
        setIsFormReady(false)
        setDataEdit(props.dataContact)
        officetimes(props.dataContact.officeTimes, false)
        setErrorMessage(initStateErrorMessage)
        const timer = setTimeout(() => setIsFormReady(true), 0)
        return () => clearTimeout(timer)
    }, [props.dataContact]);

    const handleCancel = () => {
        if (props.dataContact?.name) {
            onEdit(props.index, true, dataEdit.contactCustomerId)
        } else {
            setDataEdit({})
            setBranchTimes([...objBranchTime])
            setErrorMessage(initStateErrorMessage)
        }
    }

    const officetimes = useCallback((times, status) => {
        if (times === undefined) {
            setBranchTimes([...objBranchTime]);
        } else if (times) {
            const tempOfficeTime: any = []
            for (const officeTime in times) {
                if (Object.prototype.hasOwnProperty.call(times, officeTime)) {
                    const ot = times[officeTime];
                    if (ot) {
                        tempOfficeTime.push({
                            timeStart: ot.timeIn,
                            timeEnd: ot.timeOut,
                            typetime: ot.officeStatus,
                            days: {
                                sun: ot?.day.indexOf('Sun') !== -1 ? true : false,
                                mon: ot?.day.indexOf('Mon') !== -1 ? true : false,
                                tue: ot?.day.indexOf('Tue') !== -1 ? true : false,
                                wed: ot?.day.indexOf('Wed') !== -1 ? true : false,
                                thu: ot?.day.indexOf('Thu') !== -1 ? true : false,
                                fri: ot?.day.indexOf('Fri') !== -1 ? true : false,
                                sat: ot?.day.indexOf('Sat') !== -1 ? true : false
                            }
                        });
                    }
                }
            }
            if (dataEdit.contactCustomerId !== undefined) setBranchTimes(tempOfficeTime);
            if (status && dataEdit.contactCustomerId === undefined) setBranchTimes(tempOfficeTime);
        }
    }, []);


    const handleChangeBranchTimeType = (value: string, index: number) => {
        const branchTimeTemp: any = [...branchTimes]
        branchTimeTemp[index].typetime = value
        setBranchTimes(branchTimeTemp)
        setDataEdit({ ...dataEdit, officeTimes })
    }

    const handleChangeBranchTimeDate = (day: string, index: number) => {
        const branchTimeTemp: any = [...branchTimes]
        branchTimeTemp[index].days[day] = !branchTimeTemp[index].days[day]
        setBranchTimes(branchTimeTemp)
        setDataEdit({ ...dataEdit, officeTimes })
    }

    const handleChangeBranchTime = (times: any, index: number) => {
        const branchTimeTemp: any = [...branchTimes]
        branchTimeTemp[index].timeStart = times[0]
        branchTimeTemp[index].timeEnd = times[1]
        setBranchTimes(branchTimeTemp)
        setDataEdit({ ...dataEdit, officeTimes })
    }

    const addBranchTime = () => setBranchTimes([...branchTimes, ...objBranchTime])

    const deleteBranchTime = (e: any, index: number) => {
        const branchTimeTemp: any = []
        for (const iBt in branchTimes) {
            if (Object.prototype.hasOwnProperty.call(branchTimes, iBt)) {
                const element = branchTimes[iBt]
                if (Number(iBt) !== Number(index)) branchTimeTemp.push(element)
            }
        }
        setBranchTimes(branchTimeTemp)
    }

    const onPull = (status: boolean, item?: any) => {
        if (item) {
            officetimes(item.officeTimes, true)
            const newPayload: any = {
                contactCustomerId: 0,
                branchId: item.branchId,
                name: item.branchName,
                email: item.branchEmail,
                phone: item.branchPhone,
                detail: item.branchFullAddress,
                addressMap: item.addressMap ?? '',
                website: '',
                tiktok: '',
                facebook: item.branchFacebook,
                line: item.branchLine,
                instagram: item.branchInstagram,
                officeTimes: item.officeTimes,
                isEdit: status,
                isPull: !status
            }
            setDataEdit({ ...newPayload })
        }
    }


    const onSave = async (i: number, branchId: number) => {
        const dateTimes = branchTimes.map((item: any) => {
            const { typetime, timeStart, timeEnd, days } = item;
            return Object.keys(days).map(day => {
                if (days[day]) {
                    return {
                        dayOfWeek: day.charAt(0).toUpperCase() + day.slice(1),
                        timeIn: typetime === 'OPEN' ? timeStart : '00:00',
                        timeOut: typetime === 'OPEN' ? timeEnd : '00:00',
                        officeStatus: typetime
                    };
                }
                return null;
            }).filter(Boolean);
        }).flat();
        const arr: any = [];
        dateTimes.forEach((e: any) => { arr.push(e.dayOfWeek) });
        const newPayload: WebContactUsProps = Object.assign(dataEdit, { branchId: branchId, officeTimes: [...dateTimes] })
        const id = dataEdit.contactCustomerId || 0

        const sun = branchTimes.filter((bt: any) => Boolean(bt.days.sun) === true)
        const mon = branchTimes.filter((bt: any) => Boolean(bt.days.mon) === true)
        const tue = branchTimes.filter((bt: any) => Boolean(bt.days.tue) === true)
        const wed = branchTimes.filter((bt: any) => Boolean(bt.days.wed) === true)
        const thu = branchTimes.filter((bt: any) => Boolean(bt.days.thu) === true)
        const fri = branchTimes.filter((bt: any) => Boolean(bt.days.fri) === true)
        const sat = branchTimes.filter((bt: any) => Boolean(bt.days.sat) === true)

        if (!newPayload.name || !newPayload.email || !newPayload.phone || !newPayload.detail || branchTimes.length === 0 ||
            (_.isEmpty(sun) || _.isEmpty(mon) || _.isEmpty(tue) || _.isEmpty(wed) || _.isEmpty(thu) || _.isEmpty(fri) || _.isEmpty(sat)) ||
            (_.size(sun) > 1 || _.size(mon) > 1 || _.size(tue) > 1 || _.size(wed) > 1 || _.size(thu) > 1 || _.size(fri) > 1 || _.size(sat) > 1) ||
            (_.some(branchTimes, d => d.typetime === 'CLOSE' && _.every(d.days)))
        ) {
            let keyName = ''
            if (!newPayload.name) keyName = 'name="name"'
            else if (!newPayload.email) keyName = 'name="email"'
            else if (!newPayload.phone) keyName = 'name="phone"'
            else if (!newPayload.detail) keyName = 'name="detail"'

            if (keyName) {
                const inputs: any = document.querySelector(`input[${keyName}]`);
                if (inputs) { inputs.focus(); }
            }

            if (_.isEmpty(sun) || _.isEmpty(mon) || _.isEmpty(tue) || _.isEmpty(wed) || _.isEmpty(thu) || _.isEmpty(fri) || _.isEmpty(sat)) {
                notiError(t(`${t_CONTACT_US}.DATE_NOT_COMPLETE`))
            }

            return setErrorMessage({
                ...errorMessage,
                ...{
                    CN_NAME: !newPayload.name ? t(`${t_CONTACT_US}.VALIDATION.CN_NAME`) : '',
                    EMAIL: !newPayload.email ? t(`${t_CONTACT_US}.VALIDATION.EMAIL`) : '',
                    PHONE: !newPayload.phone ? t(`${t_CONTACT_US}.VALIDATION.PHONE`) : '',
                    DETAIL: !newPayload.detail ? t(`${t_CONTACT_US}.VALIDATION.DETAIL`) : '',
                    WORK_TIME_LIST: branchTimes.length === 0 ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.WORK_TIME_LIST`) : '',
                    WORK_TIME: t(`BRANCH.MESSAGE.ERROR_MESSAGE.WORK_TIME`),
                }
            })
        }

        if (newPayload.name && newPayload.email && newPayload.phone && newPayload.detail && arr.every((item: string, index: number) => arr.indexOf(item) === index)) {
            setStatusAdd(true)
            if (id === 0) {
                const payload = {
                    contactCustomerId: newPayload.branchId,
                    name: newPayload.name,
                    email: newPayload.email,
                    phone: newPayload.phone,
                    detail: newPayload.detail,
                    branchId: newPayload.branchId,
                    officeTimes: newPayload.officeTimes ?? [],
                    addressMap: newPayload.addressMap ?? '',
                    website: newPayload.website ?? '',
                    tiktok: newPayload.tiktok ?? '',
                    facebook: newPayload.facebook ?? '',
                    line: newPayload.line ?? '',
                    instagram: newPayload.instagram ?? '',
                };
                delete dataEdit.contactCustomerId
                const res = await ManageWebApi.createWebContactUs(payload)
                if (res === "pass") {
                    onEdit(i, true, newPayload, 'pass')
                } else {
                    onEdit(i, true, newPayload, 'error')
                }
            } else {
                const res = await ManageWebApi.updateWebContactUs(newPayload.branchId, newPayload)
                if (res === "pass") {
                    onEdit(i, true, newPayload, 'pass')
                } else {
                    onEdit(i, true, newPayload, 'error')
                }
            }
            setStatusAdd(false)
        } else {
            notiError(t(`${t_CONTACT_US}.NOTI_DAY`))
        }
    }



    const onEdit = (i: number, status: boolean, item?: any, pass?: string) => {
        if (item && item.name !== undefined) {
            setDataEdit(item)
        }
        if (pass && item > 0) {
            setBranchTimes([...objBranchTime])
            props.setStatus({ status: status, newPayload: item, pass: 'cancel' })
        } else if (pass === undefined && item === 0) {
            setDataEdit({})
            setBranchTimes([...objBranchTime])
        } else {
            setBranchTimes([...objBranchTime])
            props.setStatus({ status: status, newPayload: item, pass: pass })
        }
    }


    const renderErrorWorkTime = (index: number) => {
        if (branchTimes.length) {
            const data: any = branchTimes[index]
            const dayCurrent = Object.keys(data.days).filter((day) => data.days[day] === true)
            const check = branchTimes.some((item: any, num: any) => Object.entries(item.days).some(([day, value]) => dayCurrent.includes(day) && value) && index !== num)
            if (check) {
                return (<HelperText label={t('BRANCH.MESSAGE.ERROR_MESSAGE.DATE_ALREADY_SELECT')} />)
            } else if (!dayCurrent.length) {
                return (<HelperText label={errorMessage.WORK_TIME} />)
            } else {
                return <></>
            }
        } else {
            return <></>
        }
    }

    if (!isFormReady) {
        return <Loading show={true} />
    }

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', paddingRight: '16px' }} key={props.index}>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: 'column', alignItems: 'flex-start', gap: 2, mb: 2 }} >
                    <Box sx={{ fontSize: 18, fontWeight: 600, width: '100%' }}>{t(`${t_CONTACT_US}.TITLE`)}</Box>
                    <MainButton
                        type="primary"
                        startIcon={<BtnCopy />}
                        variant="outlined"
                        title={t(`${t_CONTACT_US}.BTN_PULL`)}
                        onClick={() => onPull(false, props.branchContact[props.index])}
                        style={{ width: '100%' }}
                    />
                    <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                        <MainButton
                            variant="outlined"
                            type="secondary"
                            title={t(`${t_CONTACT_US}.BTN_CANCEL`)}
                            onClick={handleCancel}
                            //onClick={() => onEdit(props.index, true, dataEdit.contactCustomerId)}
                            disabled={!props.dataContact?.name && _.isEmpty(dataEdit)}
                            style={{ width: '100%' }}
                        />
                        <MainButton
                            title={t(`${t_CONTACT_US}.BTN_SAVE`)}
                            disabled={statusAdd}
                            variant="contained"
                            type="primary"
                            onClick={() => onSave(props.index, props.branchContact[props.index].branchId)}
                            style={{ width: '100%' }}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', justifyContent: 'space-between', mb: 2 }} >
                    <Box sx={{ fontSize: 20, fontWeight: 600 }}> {t(`${t_CONTACT_US}.TITLE`)} </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <MainButton
                            type="primary"
                            startIcon={<BtnCopy />}
                            variant="outlined"
                            title={t(`${t_CONTACT_US}.BTN_PULL`)}
                            onClick={() => onPull(false, _.find(props.branchContact, (item) => item?.branchId === props.branchId))}
                            style={{ width: 'auto' }}
                        />
                        <MainButton
                            variant="outlined"
                            type="secondary"
                            title={t(`${t_CONTACT_US}.BTN_CANCEL`)}
                            onClick={handleCancel}
                            //onClick={() => onEdit(props.index, true, dataEdit.contactCustomerId)}
                            disabled={!props.dataContact?.name && _.isEmpty(dataEdit)}
                            style={{ width: '120px' }}
                        />
                        <MainButton
                            title={t(`${t_CONTACT_US}.BTN_SAVE`)}
                            disabled={statusAdd}
                            variant="contained"
                            type="primary"
                            onClick={() => onSave(props.index, props.branchContact[props.index].branchId)}
                            style={{ width: '120px' }}
                        />
                    </Box>
                </Box>

                <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputTextField
                                required
                                label={t(`${t_CONTACT_US}.NAME`)}
                                value={dataEdit?.name ?? ''}
                                onchange={(e) => setDataEdit({ ...dataEdit, name: e.target.value })}
                                helperText={dataEdit?.name ? '' : errorMessage.CN_NAME}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputTextField
                                required
                                label={t(`${t_CONTACT_US}.EMAIL`)}
                                value={dataEdit?.email ?? ''}
                                onchange={(e) => setDataEdit({ ...dataEdit, email: e.target.value })}
                                helperText={dataEdit?.email ? '' : errorMessage.EMAIL}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputTextField
                                required
                                label={t(`${t_CONTACT_US}.TELEPHONE`)}
                                value={dataEdit?.phone ?? ''}
                                onchange={(e) => setDataEdit({ ...dataEdit, phone: e.target.value })}
                                helperText={dataEdit?.phone ? '' : errorMessage.PHONE}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ marginTop: '8px' }}>
                    <InputTextarea
                        required
                        label={t(`${t_CONTACT_US}.FULL_ADDRESS`)}
                        value={dataEdit?.detail ?? ''}
                        onchange={(e) => {
                            setDataEdit({ ...dataEdit, detail: e.target.value })
                        }}
                        helperText={dataEdit?.detail ? '' : errorMessage.DETAIL}
                    />
                </Box>
                <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: 'block' }}>
                    <Typography mb={3} sx={{ fontSize: '18px', fontWeight: 500 }}>
                        {t('BRANCH.TAB.WORK_TIME_TITLE')}
                    </Typography>
                    <Table sx={{ border: `1px solid ${colors.lightGray}`, minWidth: 800, borderCollapse: 'separate', borderSpacing: 0, borderRadius: '10px', overflow: 'hidden' }}>
                        <TableHead sx={{ backgroundColor: '#2F4269' }}>
                            <TableRow>
                                <TableCell sx={{ fontSize: '16px', color: colors.white, borderTopLeftRadius: '10px' }}> {t('BRANCH.INPUT.WORK_DATE_COL')} </TableCell>
                                <TableCell sx={{ fontSize: '16px', color: colors.white, width: '320px' }}>{t('TIME_DURATION_TYPE.DAY')}</TableCell>
                                <TableCell sx={{ fontSize: '16px', color: colors.white }} > {t('BRANCH.INPUT.WORK_TIME')}</TableCell>
                                <TableCell align="center" sx={{ fontSize: '16px', color: colors.white, borderTopRightRadius: '10px' }} > Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <a className="btn text-second" onClick={() => {
                                        setErrorMessage((pre) => ({ ...pre, WORK_TIME_LIST: '' }))
                                        addBranchTime()
                                    }}>
                                        <span style={{ color: colors.themeSecondColor }}>+</span>
                                        <span className="ml-1" style={{ color: colors.themeSecondColor }}>
                                            {t('BRANCH.TAB.ADD_ITEM_WORK')}
                                        </span>
                                    </a>
                                    {(errorMessage.WORK_TIME_LIST) &&
                                        <Box padding='0 12px 0 12px' marginBottom={2}>
                                            <HelperText label={errorMessage.WORK_TIME_LIST} />
                                        </Box>
                                    }
                                </TableCell>
                            </TableRow>
                            {branchTimes.map((branchTime: any, iBranchTime: any) => (
                                <TableRow key={`row-${iBranchTime}`} sx={{ 'td': { padding: errorMessage.WORK_TIME ? '.5rem .5rem 1.5rem .5rem' : '' } }}>
                                    <TableCell>
                                        <BasicSelect
                                            onchange={(event) => {
                                                const value = event.target.value
                                                if (value) {
                                                    handleChangeBranchTimeType(value, iBranchTime)
                                                }
                                            }}
                                            label={''}
                                            selectId="select-status"
                                            value={branchTime.typetime}
                                            labelId="label-status"
                                            options={[
                                                <MenuItem key="1" value="OPEN">
                                                    {t('BRANCH.INPUT.WORK_DATE_TYPE_OPEN')}
                                                </MenuItem>,
                                                <MenuItem key="2" value="CLOSE">
                                                    {t('BRANCH.INPUT.WORK_DATE_TYPE_CLOSE')}
                                                </MenuItem>
                                            ]}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {dateOfWeek.map((day, i) => (
                                            <UseStyles.BtnDay
                                                key={day}
                                                className={`btn mx-1 text-nowrap text-center px-1 btn-day d-inline-flex align-items-center justify-content-center ${branchTime.days[day.toLowerCase()] ? 'active' : ''} ${branchTime.typetime === 'OPEN' ? 'open' : 'close'
                                                    }`}
                                                onClick={(e) => {
                                                    setErrorMessage((pre) => ({ ...pre, WORK_TIME: '' }))
                                                    handleChangeBranchTimeDate(day.toLowerCase(), iBranchTime)
                                                }}
                                            >
                                                {t(`DAY_SHORT_${day.toUpperCase()}`)}
                                            </UseStyles.BtnDay>
                                        ))}
                                        {(errorMessage.WORK_TIME) &&
                                            <Box sx={{ marginTop: '6px' }}>
                                                {renderErrorWorkTime(iBranchTime)}
                                            </Box>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <InputNewRangeTimePicker
                                            value={[moment(branchTime.timeStart, 'HH:mm').format('HH:mm'), moment(branchTime.timeEnd, 'HH:mm').format('HH:mm')]}
                                            onChange={(e) => handleChangeBranchTime(e, iBranchTime)}
                                            disabled={branchTime.typetime === 'CLOSE'}
                                            style={{ maxWidth: '300px' }}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton
                                            className={'btn-delete'}
                                            disableFocusRipple
                                            disableRipple
                                            disableTouchRipple
                                            aria-label="delete"
                                            onClick={(e) => deleteBranchTime(e, iBranchTime)}
                                            sx={{
                                                backgroundColor: 'transparent !important',
                                                padding: 0,
                                                '&:disabled': {
                                                    filter: 'grayscale(1)',
                                                    opacity: 0.6
                                                }
                                            }}
                                        >
                                            <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                <Box sx={{ paddingTop: '20px' }}>
                    <InputTextField
                        label={t(`${t_CONTACT_US}.IFRAME`)}
                        value={dataEdit?.addressMap ?? ''}
                        onchange={(e) => {
                            setDataEdit({ ...dataEdit, addressMap: e.target.value })
                        }}
                    />
                </Box>
                <Box sx={{ marginTop: '16px', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ fontWeight: '500' }}>
                        {t(`${t_CONTACT_US}.CHANNEL_CONTACT`)}
                    </Box>
                    <UseStyles.ContainerSocial>
                        <Box sx={{ width: '10%', paddingRight: '40px' }}><BtnWebsite color="#808080" width="28" height="28" /></Box>
                        <Box sx={{ width: '90%' }}>
                            <InputTextField
                                label={t(`${t_CONTACT_US}.SOCIAL.WEBSITE`)}
                                value={dataEdit?.website ?? ''}
                                onchange={(e) => {
                                    setDataEdit({ ...dataEdit, website: e.target.value })
                                }}
                            />
                        </Box>
                    </UseStyles.ContainerSocial>
                    <UseStyles.ContainerSocial>
                        <Box sx={{ width: '10%', paddingRight: '40px' }}><BtnFacebook color="#808080" width="28" height="28" /></Box>
                        <Box sx={{ width: '90%' }}>
                            <InputTextField
                                label={t(`${t_CONTACT_US}.SOCIAL.FACEBOOK`)}
                                value={dataEdit?.facebook ?? ''}
                                onchange={(e) => {
                                    setDataEdit({ ...dataEdit, facebook: e.target.value })
                                }}
                            />
                        </Box>
                    </UseStyles.ContainerSocial>
                    <UseStyles.ContainerSocial>
                        <Box sx={{ width: '10%', paddingRight: '40px' }}><BtnLine color="#808080" width="30" height="30" /></Box>
                        <Box sx={{ width: '90%' }}>
                            <InputTextField
                                label={t(`${t_CONTACT_US}.SOCIAL.LINE`)}
                                value={dataEdit?.line ?? ''}
                                onchange={(e) => {
                                    setDataEdit({ ...dataEdit, line: e.target.value })
                                }}
                            />
                        </Box>
                    </UseStyles.ContainerSocial>
                    <UseStyles.ContainerSocial>
                        <Box sx={{ width: '10%', paddingRight: '40px' }}><BtnIG color="#808080" width="32" height="32" /></Box>
                        <Box sx={{ width: '90%' }}>
                            <InputTextField
                                label={t(`${t_CONTACT_US}.SOCIAL.INSTAGRAM`)}
                                value={dataEdit?.instagram ?? ''}
                                onchange={(e) => {
                                    setDataEdit({ ...dataEdit, instagram: e.target.value })
                                }}
                            />
                        </Box>
                    </UseStyles.ContainerSocial>
                    <UseStyles.ContainerSocial >
                        <Box sx={{ width: '10%', paddingRight: '40px' }}><BtnTiktok color="#808080" /></Box>
                        <Box sx={{ width: '90%' }}>
                            <InputTextField
                                label={t(`${t_CONTACT_US}.SOCIAL.TIKTOK`)}
                                value={dataEdit?.tiktok ?? ''}
                                onchange={(e) => {
                                    setDataEdit({ ...dataEdit, tiktok: e.target.value })
                                }}
                            />
                        </Box>
                    </UseStyles.ContainerSocial>
                </Box>
            </Box>
        </>
    )
}

export default ContactUsForm
